import { Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { colors } from "../../../../ui/colors";

interface Props {
  client: any;
}

export const JobCardClient = ({ client }: Props) => {
  if (!client) return null;

  return (
    <Box display="flex" alignItems="center" gap={1.5} mt={2}>
      <PersonIcon sx={{ color: colors.orange.base, fontSize: 20 }} />
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: colors.gray[400],
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            fontSize: "0.6rem",
            display: "block",
          }}
        >
          Client
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500, color: colors.gray[700], fontSize: "0.74rem", lineHeight: 1.35 }}>
          {client.firstName} {client.lastName}
        </Typography>
      </Box>
    </Box>
  );
};
